interface VehicleDataApiData {
  model: string;
  brand: string;
  version: string;
  vehicle_type: string;
  year_manufacture: string;
  year_model: string;
  vehicle_type_code?: string;
}

class VehicleData {
  public model: string;
  public brand: string;
  public version: string;
  public vehicleType: string;
  public yearManufacture: string;
  public yearModel: string;
  public vehicleTypeCode: string;

  public constructor(data: VehicleDataApiData = {
    model: "",
    brand: "",
    version: "",
    vehicle_type: "",
    year_manufacture: "",
    year_model: ""
  }) {
    this.model = data.model;
    this.brand = data.brand;
    this.version = data.version;
    this.vehicleType = data.vehicle_type;
    this.yearManufacture = data.year_manufacture;
    this.yearModel = data.year_model;
    this.vehicleTypeCode = data.vehicle_type_code || "";
  }

  public formatPayload(): any {
    const payload: any = {
      model: this.model,
      brand: this.brand,
      version: this.version,
      vehicle_type: this.vehicleType,
      year_manufacture: this.yearManufacture,
      year_model: this.yearModel
    };

    if (this.vehicleTypeCode) {
      payload.vehicle_type_code = this.vehicleTypeCode;
    }

    return payload;
  }
}

export default VehicleData;
